import { appStore } from "../state/store";
import { ProgressBar } from "./ProgressBar";
export class SevenStories {
    constructor(app) {
        this.app = app;
        this.progressBar = new ProgressBar(6, 2);
    }
    render() {
        // Read initial stories from the store instead of a hardcoded array.
        const initialStories = appStore.getState().user.onboardingInputs.sevenStories;
        const storiesHtml = initialStories.map((story, index) => `
            <div class="form-group">
                <label for="story-${index + 1}">Story ${index + 1}: A time you felt successful and proud</label>
                <textarea id="story-${index + 1}" class="story-input" rows="3">${story.narrative}</textarea>
            </div>
        `).join('');
        return `
            <div class="card">
                ${this.progressBar.render()}
                <h2>Step 2: Capture Narrative Data</h2>
                <p>We will now capture qualitative <strong>Representations</strong> of your past achievements. This narrative data helps the system understand the context behind your successes, forming the basis for an initial psychometric inference.</p>
                <form id="stories-form">
                    ${storiesHtml}
                    <div class="button-container">
                        <button type="submit" class="button-primary">Next</button>
                    </div>
                </form>
            </div>
        `;
    }
    attachEventListeners() {
        var _a;
        (_a = document.getElementById('stories-form')) === null || _a === void 0 ? void 0 : _a.addEventListener('submit', (e) => {
            e.preventDefault();
            const stories = Array.from(document.querySelectorAll('.story-input'))
                .map(textarea => textarea.value);
            appStore.updateSevenStories(stories);
            this.app.nextStep();
        });
    }
}
